import type { RecommendationCardContentProps } from "./recommendation-card-content.type";

import { StopOutlined } from "@ant-design/icons";
import { Empty } from "antd";
import { useTranslation } from "react-i18next";

import RecommendationAddButton from "@/modules/recommendation/recommendation-add-button";
import RecommendationAddInterventionButton from "@/modules/recommendation/recommendation-add-intervention-button";
import RecommendationDisableToggleButton from "@/modules/recommendation/recommendation-disable-toggle-button";
import RecommendationInterventionsTable from "@/modules/recommendation/recommendation-interventions-table";
import RecommendationSelectButton from "@/modules/recommendation/recommendation-select-button";

import "./recommendation-card-content.style.less";

const RecommendationCardContent = ({
  intervention,
  interventionAsset,
  observation,
  disabled,
}: RecommendationCardContentProps) => {
  const { t } = useTranslation();

  if (!observation?.id) return null;

  if (observation.recommendation) {
    return (
      <div>
        <RecommendationAddInterventionButton
          interventionAsset={interventionAsset}
          observation={observation}
        />
        <RecommendationInterventionsTable observation={observation} />
      </div>
    );
  }

  if (!observation.needs_recommendation) {
    return (
      <div className="recommendation-card-content-center -empty">
        <Empty
          description={t("recommendation:noRecommendations.active")}
          image={<StopOutlined />}
          className="no-recommendations-infos"
        />
      </div>
    );
  }

  return (
    <div className="recommendation-card-content-center">
      <RecommendationDisableToggleButton
        observationId={observation.id}
        action="enable"
        buttonProps={{ disabled }}
      />
      <RecommendationAddButton
        interventionId={intervention.id}
        observationId={observation.id}
        disabled={disabled}
      />
      <RecommendationSelectButton
        interventionId={intervention.id}
        observationId={observation.id}
        disabled={disabled}
      />
    </div>
  );
};

export default RecommendationCardContent;
